// Six headline numbers at the top of the platform-admin screen. Mirrors the
// FrenchPrep control-tower design: dense, glanceable, color-coded by kind.
import React from 'react';
import { Building2, GraduationCap, Users, UserCheck, CalendarDays, Calendar } from 'lucide-react';

const CARDS = [
  { key: 'centers',           label: 'Centers',         icon: Building2,     tint: 'text-slate-900' },
  { key: 'instructors',       label: 'Instructors',     icon: GraduationCap, tint: 'text-cyan-700' },
  { key: 'active_students',   label: 'Active Students', icon: Users,         tint: 'text-emerald-700' },
  { key: 'all_time_students', label: 'All-time',        icon: UserCheck,     tint: 'text-slate-700' },
  { key: 'this_month',        label: 'This month',      icon: CalendarDays,  tint: 'text-blue-700' },
  { key: 'this_year',         label: 'This year',       icon: Calendar,      tint: 'text-amber-700' },
];

export default function AdminKpis({ data }) {
  return (
    <div className="mt-6 grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6" data-testid="admin-kpis">
      {CARDS.map(({ key, label, icon: Icon, tint }) => (
        <div key={key} className="rounded-lg border border-slate-200 bg-white px-4 py-3.5" data-testid={`kpi-${key}`}>
          <Icon className={`h-4 w-4 ${tint}`} />
          <p className={`mt-2 font-display text-3xl font-extrabold tabular-nums ${tint}`}>
            {data ? data[key] ?? 0 : '—'}
          </p>
          <p className="mt-0.5 text-[11px] font-semibold uppercase tracking-wider text-slate-400">{label}</p>
        </div>
      ))}
    </div>
  );
}
